import React from 'react';
import PropTypes from 'prop-types';
import { EVENT_FAQ_CONST } from './data/constants';
import { AVOptionsSelected, AVRulesSelected, AVRulesExplicitlyProhibited } from './data/utils';
import AVMusicContent from './content/AVMusicContent';
import AVMusicExpanded from './content/AVMusicExpanded';

const AVMusic = ({ faqData = {}, expanded = false }) => {
  const { MISC_AV_EQUIPMENT } = EVENT_FAQ_CONST;
  const availableEquipment = AVOptionsSelected(faqData);
  const avRulesSelected = AVRulesSelected(faqData);
  const AVRulesProhibited = AVRulesExplicitlyProhibited(faqData);
  const hasRulesForAV = 0 < avRulesSelected.length || 0 < AVRulesProhibited.length;
  const hasOtherAVEquipment = faqData.hasOwnProperty(MISC_AV_EQUIPMENT) && '' !== faqData[MISC_AV_EQUIPMENT].description;
  if (expanded) {
    return (
      <>
        <AVMusicExpanded
          faqData = {faqData}
          availableEquipment={availableEquipment}
        />
      </>
    );
  }
  return (
    <>
      <AVMusicContent
        faqData = {faqData}
        availableEquipment={availableEquipment}
        hasOtherAVEquipment={hasOtherAVEquipment}
        hasRulesForAV={hasRulesForAV}
        avRulesSelected={avRulesSelected}
        AVRulesProhibited={AVRulesProhibited}
      />
    </>
  );
};

AVMusic.propTypes = {
  faqData: PropTypes.object,
  expanded: PropTypes
};

export default AVMusic;
